import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M20.32,7.64v5.29h-1.5V8.64H13.56V3.38H6.67A2.25,2.25,0,0,0,4.42,5.63V18.37a2.25,2.25,0,0,0,2.25,2.25H14v1.5H6.67a3.76,3.76,0,0,1-3.75-3.75V5.63A3.76,3.76,0,0,1,6.67,1.88h7.89ZM22,18.9H20.32V17.21a.75.75,0,0,0-1.5,0V18.9H17.15a.75.75,0,0,0,0,1.5h1.67v1.7a.75.75,0,0,0,1.5,0V20.4H22a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentPlusCircleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentPlusCircle')) as IconWithRender;

DocumentPlusCircleIcon.displayName = 'DocumentPlusCircleIcon';
DocumentPlusCircleIcon.propTypes = Icon.propTypes;
DocumentPlusCircleIcon.renderIcon = (props) => (
  <DocumentPlusCircleIcon {...props} />
);
export default DocumentPlusCircleIcon;
